export const GDA_ELIGIBLE = 'GDAEligible';
export const GDA_MEMBER = 'GDAMember';
export const GDA_COOKIE_NAME = 'GDA';
export const GDA_TYPE_ID = 10;
export const FEATURED = 'gdaFeatured';
export const BOTH = 'both';
export const VENUE_LIMIT = 6;
export const PLATINUM_CODE = '2X';
export const PLATINUM_CARD = 'Platinum';
export const PLATINUM_CARD_ID = '1';
export const FAQS_URL = './global-dining-access#faqs';
